export const MOBILE_BREAKPOINT = 575
export const TABLET_BREAKPOINT = 768
export const LAPTOP_BREAKPOINT = 1024
export const DESKTOP_BREAKPOINT = 1280
